import { badgeColors } from '@app/shared/components/badge/badge.component';
import { isArray, isEmpty } from 'lodash';
import { IDeviceType } from '../models/core-models';

const inputTypes = ['checkbox-input', 'text-input', 'select-input', 'img-input', 'radio-input', 'textarea-input'];

export const urlConfigInputTypes = {
  checkbox: inputTypes[0],
  colorpicker: inputTypes[1],
  domain: inputTypes[2],
  editor: inputTypes[1],
  file: inputTypes[0],
  intro: inputTypes[2],
  ivr_18: inputTypes[2],
  ivr_ezo: inputTypes[2],
  landings_to_promotion: inputTypes[2],
  movie_by_id: inputTypes[1],
  movie: inputTypes[1],
  ppi_img: inputTypes[3],
  ppi_provider: inputTypes[2],
  ppi: inputTypes[2],
  radio: inputTypes[4],
  text: inputTypes[1],
  textarea: inputTypes[5]
};

export const campaignsTypesBadgesColorsMap: Record<string, badgeColors> = {
  CPL: 'red',
  CPS: 'orange',
  CPA: 'blue',
  PPI: 'green',
  COD: 'blue'
};

export const flattenCategories = (categories: IDeviceType[]): Pick<IDeviceType, 'id'>[] => {
  if (!isArray(categories)) throw Error('Categories must be array');
  if (isEmpty(categories)) return [];

  let flattenedCategories: Pick<IDeviceType, 'id'>[] = [];

  const mapCategories = (categories: IDeviceType[]) =>
    categories.map(({ id, children }) => {
      id && flattenedCategories.push({ id });

      if (children && !isEmpty(children)) {
        mapCategories(children);
      }
    });

  mapCategories(categories);

  return flattenedCategories;
};
